import React, { useState } from "react";

import "./index.scss";
import Context from "../../context";
import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";
import values from "../../values";
import constants from "../../values/constants";
import Cookies from "js-cookie";
import Components from "./Components";

type Props = {
  rqUser: any;
};

const TicketScreen = (props: Props) => {
  const { data, status } = props.rqUser;

  const { requestTicket, setRequestTicket } = React.useContext(
    Context.TicketContext
  );

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  return (
    <CustomView.Container id="super-agent-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          <Components.Create />
          {/* <Components.Filter />
          <Components.Search /> */}
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader headers={values.tableHeaders.Ticket_HEADERS} />
          {status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={data?.result?.docs} />
          )}
        </table>
      </div>
      {status === "success" &&
        data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestTicket?.page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestTicket!({ ...requestTicket, page })
              }
            />
          </div>
        )}
      <Components.ShowInfoTicket />
    </CustomView.Container>
  );
};

export default TicketScreen;
